import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText
} from 'reactstrap';
import {
  Loading
} from "common-import/custom";
import moment from 'moment';
const ReactMarkdown = require('react-markdown');
import { VarHelper } from '../../utils';

class SystemNotification extends Component {

  state = {
    isLoading: true,
    list: [],
  }

  async componentDidMount() {
    await this.loadNotification();
    this.setState({ isLoading: false })
  }

  loadNotification = async () => {
    const res = await fetch(encodeURI('https://api.mlab.com/api/1/databases/hl-noti/collections/chat-log?apiKey=eTs2gMpDmJrwzCrM-R5Iiw15zdYPkP3w&s={"timestamp": -1}'));
    const json = await res.json();
    console.log('json', json)
    this.setState({ list: json });
  }

  render() {
    const { isLoading, list } = this.state;
    if (isLoading) return (<Loading> </Loading>);
    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader>
            <h4 style={{ color: 'blue' }}>Log thông báo hệ thống</h4>
            <p style={{ color: 'grey' }}>Để nhận thông báo real time về thông báo này, tham gia Group trên Telegram tại đường dẫn: <a href="https://t.me/joinchat/AAAAAEkGfQi_lJjeDptORw" target="_blank">https://t.me/joinchat/AAAAAEkGfQi_lJjeDptORw</a></p>
          </CardHeader>
          <CardBody>
            {VarHelper.detectType(list) === 'array' && list.map((val, index) => (
              <div key={"noti"+index} style={{ marginBottom: 10, borderBottom: '1px dashed black' }}>
                {/* <pre>
                  {val.message}
                  {'\n'}
                  {new Date(val.timestamp).toISOString()}
                </pre> */}
                {/* <p></p> */}
                <ReactMarkdown source={val.message} />
                <p style={{ fontSize: 12, fontStyle: 'italic', color: 'grey' }}>{new Date(val.timestamp).toISOString()}</p>
              </div>
            ))}
          </CardBody>
        </Card>
        
        
      </div>
    );
  }
}

export default SystemNotification;


// WEBPACK FOOTER //
// ./src/views/Dashboard/SystemNotification.js